<template>

  <div>

    <portal to="toolbar-title"> Προεπισκόπηση Γεγονότος</portal>
    <portal to="toolbar-actions">
    </portal>

    <event-card hide-top-bar :key="$route.params.id" :event-id="Number($route.params.id)"/>
  </div>

</template>

<script>
import EventCard from "../components/EventCard";
import SinglePage from "@/components/templates/SinglePage";

export default {
  name: "EventPage",
  components: {SinglePage, EventCard},

}
</script>

<style scoped>

</style>
